import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import UserGroupItem from './UserGroupListItemComponent';
import { Pagination } from '@totalsoft/rocket-ui';

const UserGroupListComponent = ({
  userGroups,
  selectedUserGroups,
  dispatch,
  pager,
  onPageChange,
  onRowsPerPageChange,
  onRefresh,
  loading
}) => {
  return (
    <>
      <Grid container>
        {userGroups.map((userGroup, index) => {
          return (
            <UserGroupItem
              key={userGroup.id}
              userGroup={userGroup}
              selectedUserGroup={selectedUserGroups.find(item => item.userGroupId === userGroup.id)}
              index={index}
              dispatch={dispatch}
            />
          );
        })}
      </Grid>
      <Pagination
        loading={loading}
        count={pager.totalCount}
        pageSize={pager.pageSize}
        page={pager.page}
        onRowsPerPageChange={onRowsPerPageChange}
        onPageChange={onPageChange}
        onRefresh={onRefresh}
      />
    </>
  );
};

UserGroupListComponent.propTypes = {
  userGroups: PropTypes.array,
  selectedUserGroups: PropTypes.array,
  dispatch: PropTypes.func,
  pager: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default UserGroupListComponent;
